module.exports = __webpack_public_path__ + "static/media/aridovics.080b7597.jpg";